export const TIEMPO_MOSTRAR_ERROR = 4000;
export const noMasOpciones = () => "No hay más opciones"; // Para React-Select
export const noMasOpciones2 = () => "Debe seleccionar un Departamento u Área primero";

// articulos asignados
export const Asignado_Estados = [
    { value: 0, label: "No Asignado"}, 
    { value: 1, label: "Proceso de Ensamble"}, 
    { value: 2, label: "Proceso de Configurado"}, 
    { value: 3, label: "Almacenado"  }, 
    { value: 4, label: "Entregado"   }, 
    { value: 5, label: "Rechazado"  }, 
    { value: 6, label: "Aceptado"  },
    {value: 7, label: "Parcialmente Aceptado"},
    {value: 8, label: "No aceptado"},
    {value: 9, label: "En Mantenimiento"},
    {value: 10, label: "De baja"}    
];

// Solicitudes
export const SOLICITUD_ESTADOS = [
    { value: 0, label: "No Asignado"}, // Naranja
    { value: 1, label: "Asignado"   }, // Amarillo
    { value: 2, label: "Planificado"}, // Celeste
    { value: 3, label: "Concluido"  }, // Morado
    { value: 4, label: "Aceptado"   }, // Verde
    { value: 5, label: "Rechazado"  }, // Rojo
    { value: 6, label: "En proceso"  },  // Gris
    { value: 7, label: "Autorizado"},
];

export const MINUTOS = [
    { value: 0, label: "0 minutos"},
    { value: 1, label: "15 minutos"},
    { value: 2, label: "30 minutos"},
    { value: 3, label: "45 minutos"},
];

export const CALIFICACION_SOLICITUD = [
    "",
    "Rechazado",  // 1 
    "Malo",       // 2 
    "Regular",    // 3 
    "Bueno",      // 4 
    "Excelente"   // 5 
];


// Imagenes
export const TAMANIO_IMG_COLUMNAS_LG = 1;
export const TAMANIO_IMG_COLUMNAS_SM = 3;
export const TAMANIO_IMG_COLUMNAS_XS = 5;